import ApiService from "../../api/api.service";
import { GET_DEPOSIT_DATA, SAVE_DEPOSIT_DATA, GET_SAVING_ACCOUNT_FORM_DATA, DELETE_DEPOSIT_DATA, GET_EDIT_SAVING_ACCOUNT_FORM_DATA,
	UPDATE_DEPOSIT_DATA, GET_FIXED_DEPOSIT_FORM_DATA, GET_EDIT_FIXED_DEPOSIT_FORM_DATA, GET_RECCURING_DEPOSIT_FORM_DATA,
	 GET_EDIT_RECCURING_DEPOSIT_FORM_DATA, GET_SUKANAYA_SAMARIDDHI_FORM_DATA, GET_EDIT_SUKANAYA_SAMARIDDHI_FORM_DATA,
	 CHECK_FORM_DATA_EXISTS } from "../actions.type";

	const getDefaultDepositState = () => {
		return {
			depositData: {},
			savingAccountFormData: {},
			bankPoMasterData: {},
			editSavingAccountFormData: {},
			fixedDepositFormData: {},
			editFixedDepositFormData: {},
			reccuringDepositFormData: {},
			editReccuringDepositFormData: {},
			sukanayaSamridhiYojanaFormData: {},
			editSukanayaSamridhiYojanaFormData: {},
			checkFormDataExists: {},
		}
	};

	const state = getDefaultDepositState();

	const getters = {
		allDepositData(state) {
			return state.depositData;
		},

		getSavingAccountFormData(state) {
			return state.savingAccountFormData;
		},

		getBankPoMasterData(state) {
			return state.bankPoMasterData;
		},

		getEditSavingAccountFormData(state) {
			return state.editSavingAccountFormData;
		},

		getFixedDepositFormData(state) {
			return state.fixedDepositFormData;
		},

		getEditFixedDepositFormData(state) {
			return state.editFixedDepositFormData;
		},

		getReccuringDepositFormData(state) {
			return state.reccuringDepositFormData;
		},

		getEditReccuringDepositFormData(state) {
			return state.editReccuringDepositFormData;
		},

		getSukanayaSamridhiYojanaFormData(state) {
			return state.sukanayaSamridhiYojanaFormData;
		},

		getEditSukanayaSamridhiYojanaFormData(state) {
			return state.editSukanayaSamridhiYojanaFormData;
		},

		getCheckFormDataExists(state) {
			return state.checkFormDataExists;
		},
	};

	const mutations = {

		setDepositData (state, data) {
			state.depositData = data
		},

		setSavingAccountFormData (state, data) {
			state.savingAccountFormData = data
		},

		setBankPoMasterData(state,data) {
			return state.bankPoMasterData = data;
		},

		setEditSavingAccountFormData(state, data) {
			return state.editSavingAccountFormData = data;
		},

		setFixedDepositFormData(state, data) {
			return state.fixedDepositFormData = data;
		},

		setEditFixedDepositFormData(state, data) {
			return state.editFixedDepositFormData = data;
		},

		setReccuringDepositFormData(state, data) {
			return state.reccuringDepositFormData = data;
		},

		setEditReccuringDepositFormData(state, data) {
			return state.editReccuringDepositFormData = data;
		},

		setSukanayaSamridhiYojanaFormData(state, data) {
			return state.sukanayaSamridhiYojanaFormData = data;
		},

		setEditSukanayaSamridhiYojanaFormData(state, data) {
			return state.editSukanayaSamridhiYojanaFormData = data;
		},

		setCheckFormDataExists(state, data) {
			return state.checkFormDataExists = data;
		},

	};


	const actions = {

		[GET_DEPOSIT_DATA](context, credentials) {
			return new Promise((resolve, reject) => {
				ApiService.setHeader();

				ApiService.post(credentials.api, credentials.data)
				.then(({ data }) => {
					if (data.message == 'Unauthenticated') {
						window.location.replace('/');
					}
					context.commit('setDepositData',data);
					resolve();
				})
				.catch(({ response }) => {
					console.log("Something went wrong");
				});
			})
			.catch(response => {
				console.log(response,'post');
				if(response.logout == true)
				{

					window.location.replace('/');

				}
				console.log("Something went wrong");
			});
		},

		[SAVE_DEPOSIT_DATA](context, credentials) {
			return new Promise((resolve, reject) => {
				ApiService.setHeader();

				ApiService.post(credentials.api, credentials.data)
				.then(({ data }) => {
					if (data.message == 'Unauthenticated') {
						window.location.replace('/');
					}
					resolve();
				})
				.catch(({ response }) => {
					console.log("Something went wrong");
				});
			})
			.catch(response => {
				console.log(response,'post');
				if(response.logout == true)
				{

					window.location.replace('/');

				}
				console.log("Something went wrong");
			});
		},

		[GET_SAVING_ACCOUNT_FORM_DATA](context, credentials) {
			return new Promise((resolve, reject) => {
				ApiService.setHeader();

				ApiService.post(credentials.api, credentials.data)
				.then(({ data }) => {

					if (data.message == 'Unauthenticated') {
						window.location.replace('/');
					}

					context.commit('setSavingAccountFormData',data);

					data.data.master_data.forEach(element => {

						if (element.AccountType) {
							context.commit('setBankPoMasterData',element.AccountType);
						}

					});

					resolve();
				})
				.catch(({ response }) => {
					console.log("Something went wrong");
				});
			})
			.catch(response => {
				console.log(response,'post');
				if(response.logout == true)
				{

					window.location.replace('/');

				}
				console.log("Something went wrong");
			});
		},

		[GET_EDIT_SAVING_ACCOUNT_FORM_DATA](context, credentials) {
			return new Promise((resolve, reject) => {
				ApiService.setHeader();

				ApiService.post(credentials.api, credentials.data)
				.then(({ data }) => {

					if (data.message == 'Unauthenticated') {
						window.location.replace('/');
					}

					context.commit('setEditSavingAccountFormData',data);

					data.data.master_data.forEach(element => {

						if (element.AccountType) {
							context.commit('setBankPoMasterData',element.AccountType);
						}

					});

					resolve();
				})
				.catch(({ response }) => {
					console.log("Something went wrong");
				});
			})
			.catch(response => {
				console.log(response,'post');
				if(response.logout == true)
				{

					window.location.replace('/');

				}
				console.log("Something went wrong");
			});
		},

		[DELETE_DEPOSIT_DATA](context, credentials) {
			return new Promise((resolve, reject) => {
				ApiService.setHeader();

				ApiService.post(credentials.api, credentials.data)
				.then(({ data }) => {
					if (data.message == 'Unauthenticated') {
						window.location.replace('/');
					}
					resolve();
				})
				.catch(({ response }) => {
					console.log("Something went wrong");
				});
			})
			.catch(response => {
				console.log(response,'post');
				if(response.logout == true)
				{

					window.location.replace('/');

				}
				console.log("Something went wrong");
			});
		},

		[UPDATE_DEPOSIT_DATA](context, credentials) {
			return new Promise((resolve, reject) => {
				ApiService.setHeader();

				ApiService.post(credentials.api, credentials.data)
				.then(({ data }) => {
					if (data.message == 'Unauthenticated') {
						window.location.replace('/');
					}
					resolve();
				})
				.catch(({ response }) => {
					console.log("Something went wrong");
				});
			})
			.catch(response => {
				console.log(response,'post');
				if(response.logout == true)
				{

					window.location.replace('/');

				}
				console.log("Something went wrong");
			});
		},

		[GET_FIXED_DEPOSIT_FORM_DATA](context, credentials) {
			return new Promise((resolve, reject) => {
				ApiService.setHeader();

				ApiService.post(credentials.api, credentials.data)
				.then(({ data }) => {

					if (data.message == 'Unauthenticated') {
						window.location.replace('/');
					}

					context.commit('setFixedDepositFormData',data);

					data.data.master_data.forEach(element => {

						if (element.AccountTypeDeposit) {
							context.commit('setBankPoMasterData',element.AccountTypeDeposit);
						}

					});

					resolve();
				})
				.catch(({ response }) => {
					console.log("Something went wrong");
				});
			})
			.catch(response => {
				console.log(response,'post');
				if(response.logout == true)
				{

					window.location.replace('/');

				}
				console.log("Something went wrong");
			});
		},

		[GET_EDIT_FIXED_DEPOSIT_FORM_DATA](context, credentials) {
			return new Promise((resolve, reject) => {
				ApiService.setHeader();

				ApiService.post(credentials.api, credentials.data)
				.then(({ data }) => {

					if (data.message == 'Unauthenticated') {
						window.location.replace('/');
					}

					context.commit('setEditFixedDepositFormData',data);

					data.data.master_data.forEach(element => {

						if (element.AccountTypeDeposit) {
							context.commit('setBankPoMasterData',element.AccountTypeDeposit);
						}

					});

					resolve();
				})
				.catch(({ response }) => {
					console.log("Something went wrong");
				});
			})
			.catch(response => {
				console.log(response,'post');
				if(response.logout == true)
				{

					window.location.replace('/');

				}
				console.log("Something went wrong");
			});
		},

		[GET_RECCURING_DEPOSIT_FORM_DATA](context, credentials) {
			return new Promise((resolve, reject) => {
				ApiService.setHeader();

				ApiService.post(credentials.api, credentials.data)
				.then(({ data }) => {

					if (data.message == 'Unauthenticated') {
						window.location.replace('/');
					}

					context.commit('setReccuringDepositFormData',data);

					data.data.master_data.forEach(element => {

						if (element.AccountTypeDeposit) {
							context.commit('setBankPoMasterData',element.AccountTypeDeposit);
						}

					});

					resolve();
				})
				.catch(({ response }) => {
					console.log("Something went wrong");
				});
			})
			.catch(response => {
				console.log(response,'post');
				if(response.logout == true)
				{

					window.location.replace('/');

				}
				console.log("Something went wrong");
			});
		},

		[GET_EDIT_RECCURING_DEPOSIT_FORM_DATA](context, credentials) {
			return new Promise((resolve, reject) => {
				ApiService.setHeader();

				ApiService.post(credentials.api, credentials.data)
				.then(({ data }) => {

					if (data.message == 'Unauthenticated') {
						window.location.replace('/');
					}

					context.commit('setEditReccuringDepositFormData',data);

					data.data.master_data.forEach(element => {
						if (element.AccountTypeDeposit) {
							context.commit('setBankPoMasterData',element.AccountTypeDeposit);
						}

					});

					resolve();
				})
				.catch(({ response }) => {
					console.log("Something went wrong");
				});
			})
			.catch(response => {
				console.log(response,'post');
				if(response.logout == true)
				{

					window.location.replace('/');

				}
				console.log("Something went wrong");
			});
		},

		[GET_SUKANAYA_SAMARIDDHI_FORM_DATA](context, credentials) {
			return new Promise((resolve, reject) => {
				ApiService.setHeader();

				ApiService.post(credentials.api, credentials.data)
				.then(({ data }) => {

					if (data.message == 'Unauthenticated') {
						window.location.replace('/');
					}

					context.commit('setSukanayaSamridhiYojanaFormData',data);

					data.data.master_data.forEach(element => {
						if (element.AccountType) {
							context.commit('setBankPoMasterData',element.AccountType);
						}

					});

					resolve();
				})
				.catch(({ response }) => {
					console.log("Something went wrong");
				});
			})
			.catch(response => {
				console.log(response,'post');
				if(response.logout == true)
				{

					window.location.replace('/');

				}
				console.log("Something went wrong");
			});
		},

		[GET_EDIT_SUKANAYA_SAMARIDDHI_FORM_DATA](context, credentials) {
			return new Promise((resolve, reject) => {
				ApiService.setHeader();

				ApiService.post(credentials.api, credentials.data)
				.then(({ data }) => {

					if (data.message == 'Unauthenticated') {
						window.location.replace('/');
					}

					context.commit('setEditSukanayaSamridhiYojanaFormData',data);

					data.data.master_data.forEach(element => {
						if (element.AccountType) {
							context.commit('setBankPoMasterData',element.AccountType);
						}

					});

					resolve();
				})
				.catch(({ response }) => {
					console.log("Something went wrong");
				});
			})
			.catch(response => {
				console.log(response,'post');
				if(response.logout == true)
				{

					window.location.replace('/');

				}
				console.log("Something went wrong");
			});
		},

		[CHECK_FORM_DATA_EXISTS](context, credentials) {
			return new Promise((resolve, reject) => {
				ApiService.setHeader();

				ApiService.post(credentials.api, credentials.data)
				.then(({ data }) => {

					if (data.message == 'Unauthenticated') {
						window.location.replace('/');
					}

					context.commit('setCheckFormDataExists',data);

					resolve();
				})
				.catch(({ response }) => {
					console.log("Something went wrong");
				});
			})
			.catch(response => {
				console.log(response,'post');
				if(response.logout == true)
				{

					window.location.replace('/');

				}
				console.log("Something went wrong");
			});
		},

	};

	export default {
		getters,
		actions,
		mutations,
		state
	}